var _defs, _polygon, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVesselGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    viewBox: "0 0 17.008 42.52",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#90E98B;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "17.008 42.52 8.504 36.849 0 42.52 0 19.842 7.775 0 9.233 0 17.008 19.842 17.008 42.52"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.254,.054v-.054h-1.5V.054L0,19.842v22.678l8.504-5.67,8.504,5.67V19.842L9.254,.054Zm-.083,19.789c0,.368-.299,.667-.667,.667s-.667-.299-.667-.667,.299-.668,.667-.668,.667,.3,.667,.668Zm6.336,19.874l-6.172-4.115-.832-.555-.832,.555-6.172,4.115V20.125L7.754,4.165v13.651c-.825,.307-1.417,1.096-1.417,2.026,0,1.195,.972,2.167,2.167,2.167s2.167-.972,2.167-2.167c0-.931-.592-1.719-1.417-2.026V4.165l6.254,15.96v19.591Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVesselGreen);
export default __webpack_public_path__ + "static/media/vessel_green.c2fb410967720f4f6749ff570eff6f6d.svg";
export { ForwardRef as ReactComponent };